import React, { Component } from "react";
import PropTypes from "prop-types";

import "./ErrorBoundary.scss";

class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node
  };
  static defaultProps = {
    children: null
  };

  state = {
    error: null
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    if (process.env.NODE_ENV === "production" && window.Raven) {
      window.Raven.captureException(error, { extra: errorInfo });
    }
  }

  render() {
    if (this.state.error) {
      // render fallback UI
      return (
        <div className="d-flex flex-column align-items-center ErrorBoundary modal-container">
          <i className="ErrorBoundary__Warning fa fa-warning" />
          <p>
            <strong>Er is een onverwachte fout opgetreden</strong>
          </p>
          <div>Ververs de pagina en probeer opnieuw.</div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
